import script from "./HrBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HrBanner.vue?vue&type=script&setup=true&lang=js"

import "./HrBanner.vue?vue&type=style&index=0&id=156bff1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156bff1c"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon});
